/**
 * FILE-OVERVIEW:
 * - 役割: S3ファイル画面のエントリコンテナ。
 * - 主な連携: S3FileList.js, services/s3Service.js
 * - 本番運用上の注意: ルーティング/認証条件の変更時は直接URLアクセスを確認する。
 */

import React from 'react';
import { ThemeProvider, Box } from '@mui/material';
import S3FileList from './S3FileList';
import AppHeader from '../Common/AppHeader';
import { theme } from '../../utils/colors';

interface S3FilesPageProps {
  /** App から渡されるが本コンポーネントでは未使用 */
  user?: unknown;
  /** 同上 */
  isDesk?: boolean;
  /** 同上 */
  onSignOut?: () => void;
}

const S3FilesPage = (props: S3FilesPageProps) => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          maxWidth: 1920,
          width: '100%',
          mx: 'auto',
          minHeight: '100vh',
          bgcolor: 'background.default',
        }}
      >
        <AppHeader />

        <Box
          sx={{
            maxWidth: 1680,
            width: '100%',
            mx: 'auto',
            bgcolor: 'background.paper',
          }}
        >
          <S3FileList />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default S3FilesPage;
